import { Card, CardContent, Tab, Tabs } from '@mui/material'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useTranslate } from 'react-admin'
import { useNavigate, useParams } from 'react-router-dom'
import { ExportsProvider } from '../../contexts/ExportsContext'
import { useUserStore } from '../../stores/useUserStore'
import { Forbidden } from '../Forbidden'
import styles from './Exports.module.scss'
import { SCAMExports } from './SCAMExports'

type TabOption = 'scam'

const ContextualisedExports = () => {
  const translate = useTranslate()
  const navigate = useNavigate()
  const params = useParams()
  const userStore = useUserStore()

  const [tab, setTab] = useState<TabOption>((params.exportsTab as TabOption) ?? 'scam')

  useEffect(() => {
    navigate(`/exports/${tab}`)
  }, [navigate, tab])

  const onTabChange = useCallback(
    (tabValue: TabOption) => {
      setTab(tabValue)
      navigate(`/exports/${tabValue}`)
    },
    [navigate],
  )

  const scamExport = useMemo(() => {
    if (!userStore.isAuthorised('scam_export.read')) {
      return <Forbidden permission="scam_export.read" />
    }

    return <SCAMExports />
  }, [userStore])

  return (
    <Card>
      <CardContent className={styles.container}>
        <Tabs value={tab} onChange={(_, v) => onTabChange(v)}>
          <Tab value="scam" label={translate('pages.exports.scam')} />
        </Tabs>
        {tab === 'scam' && scamExport}
      </CardContent>
    </Card>
  )
}
export const Exports = (): JSX.Element => (
  <ExportsProvider>
    <ContextualisedExports />
  </ExportsProvider>
)
